export const USER_COMPANY_KEY = 'user_company';
export const USER_INFO_KEY = 'user_info';
export const IMPERSONATE_KEY = 'impersonate';
export const IMPERSONATE_EMAIL = 'impersonate_email';
export const BANNER_PREFERENCES_KEY = 'banner_preferences';

export const API_TOKEN = 'token';
export const WEBVIEW_API_TOKEN = 'webview_api_token';

export const contentfulPages = {
  PRIVACY_POLICY: 'pc-privacypolicy',
  TOS: 'pc-termsofservice',
};
